import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const { language } = useLanguage();
  const isArabic = language === "ar";
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold">{isArabic ? "404 — الصفحة غير موجودة" : "404 — Page Not Found"}</h1>
          </div>

          <p className="mt-4 mb-6 text-sm text-muted-foreground">
            {isArabic ? "الصفحة المطلوبة غير موجودة. يمكنك العودة للرئيسية لاستكشاف خدماتنا وأعمالنا." : "This page could not be found. Visit our homepage to explore our services and projects."}
          </p>
          <Link href={"~/" + language}><Button>{isArabic ? "العودة للرئيسية" : "Back to Home"}</Button></Link>
        </CardContent>
      </Card>
    </div>
  );
}
